import React, { FC } from 'react';
import styled from 'styled-components';
import { NewRow } from 'components/molecules/new-row';
import { Task } from 'data/tasks';
import { useTranslation } from 'hooks/use-translation';

const AddTaskInternal = styled(NewRow)`
  .icon-shell {
    margin-left: var(--layout-02);
  }

  input {
    margin-left: 0;
    padding-left: var(--spacing-02);
  }
`;

interface Props {
  id: string;
  onCreate?: (task: Task) => void;
  onCreateMultiple?: (task: Task[]) => void;
  autoFocus?: boolean;
}

export const AddTask: FC<Props> = ({
  id,
  onCreate,
  onCreateMultiple,
  autoFocus,
}) => {
  const addTaskPlaceholder = useTranslation('templates.list.add_task');

  return (
    <AddTaskInternal
      id={id}
      size="small"
      autoFocus={autoFocus}
      clearOnBlur
      placeholder={addTaskPlaceholder}
      onAdd={(taskName) => {
        onCreate?.({ taskName } as unknown as Task);

        window.setTimeout(() => {
          const nameColumn = document.querySelector(
            '[row-id="provisional"] [col-id="status"]',
          ) as HTMLElement | undefined;

          if (nameColumn) {
            nameColumn.click();
          }
        }, 50);

        return Promise.resolve();
      }}
      onAddMultiple={(tasks) => {
        onCreateMultiple?.(tasks as unknown as Task[]);

        return Promise.resolve();
      }}
      bulkAddType="tasks"
    />
  );
};
